var map = {
	"./3dc.svg": 13596,
	"./Line1-ja-simple.svg": 9157,
	"./Line1-ja.svg": 16311,
	"./Line1-simple.svg": 72310,
	"./Line1.svg": 34859,
	"./Line11-ja-simple.svg": 20091,
	"./Line11-ja.svg": 44500,
	"./Line11-simple.svg": 82447,
	"./Line11.svg": 15867,
	"./Line2-simple.svg": 99934,
	"./Line2.svg": 68630,
	"./Line22-simple.svg": 12003,
	"./Line22.svg": 5525,
	"./active-container-main.svg": 78510,
	"./add-gray.svg": 72495,
	"./add-protection.svg": 5365,
	"./alarm-event-switch.svg": 81812,
	"./alarm.svg": 4302,
	"./alarms-minor-new.svg": 85806,
	"./alarms-status-critical.svg": 72477,
	"./alarms-status-info.svg": 45063,
	"./alarms-status-major.svg": 86481,
	"./alarms-status-minor.svg": 58934,
	"./alarms.svg": 63127,
	"./analysis-copy.svg": 22248,
	"./analysis-delete.svg": 94857,
	"./analysis-edit.svg": 28887,
	"./analysis.svg": 99445,
	"./anomaly-count.svg": 48107,
	"./antivirus-service-disable.svg": 20241,
	"./antivirus-service-enable.svg": 29570,
	"./antivirus-service-error.svg": 66716,
	"./antivirus-task-disable.svg": 30168,
	"./antivirus-task-enable.svg": 7992,
	"./arrow-0.svg": 47095,
	"./arrow-100.svg": 1210,
	"./arrow-bold-down-red.svg": 78580,
	"./arrow-bold-down.svg": 44379,
	"./arrow-bold-right-red.svg": 12536,
	"./arrow-bold-right.svg": 34964,
	"./arrow-both-normal.svg": 86799,
	"./arrow-break.svg": 53093,
	"./arrow-dotted-detail.svg": 84398,
	"./arrow-dotted.svg": 15298,
	"./arrow-down.svg": 39817,
	"./arrow-fault.svg": 50261,
	"./arrow-force-start.svg": 40247,
	"./arrow-fs-intra-move-creating.svg": 72768,
	"./arrow-fs-intra-move-deleting.svg": 24154,
	"./arrow-lg-down.svg": 29478,
	"./arrow-lg-top.svg": 83704,
	"./arrow-metro-0.svg": 8159,
	"./arrow-metro-deleting.svg": 17831,
	"./arrow-metro-fault.svg": 34212,
	"./arrow-metro-force-start.svg": 68046,
	"./arrow-metro-pause.svg": 29940,
	"./arrow-metro-to-creating.svg": 1974,
	"./arrow-metro-to-recover.svg": 65909,
	"./arrow-progress.svg": 77806,
	"./arrow-small.svg": 11612,
	"./arrow-split.svg": 95699,
	"./arrow-standby.svg": 85961,
	"./arrow-to-recover.svg": 55816,
	"./arrow-top.svg": 35231,
	"./arrow-two.svg": 69990,
	"./arrow-vstore-force-start.svg": 84584,
	"./arrowhead-g.svg": 22234,
	"./arrowhead-w.svg": 32865,
	"./attachment.svg": 58270,
	"./auto-download.svg": 69865,
	"./back-port-high-usage-bg.svg": 92826,
	"./back-port-high-usage-legend.svg": 46592,
	"./back-port-normal-usage-bg.svg": 67877,
	"./back-port-normal-usage-legend.svg": 78592,
	"./basic-infomation.svg": 15176,
	"./black-font-logo.svg": 36583,
	"./block-service-setting.svg": 72413,
	"./block-service.svg": 52545,
	"./cabinet-add.svg": 84197,
	"./cancel.svg": 88569,
	"./certificate-management.svg": 79148,
	"./chart-1-col.svg": 35794,
	"./chart-2-col.svg": 40294,
	"./check-disabled.svg": 52080,
	"./check.svg": 47648,
	"./cifs.svg": 29269,
	"./clone.svg": 44961,
	"./close-thin.svg": 73488,
	"./cloude-white.svg": 57589,
	"./computeNode-card.svg": 35750,
	"./config-container-main.svg": 45738,
	"./config-file-not-exist.svg": 87785,
	"./config-policy-s-add-btn.svg": 22138,
	"./configuration.svg": 997,
	"./container-configuration.svg": 58566,
	"./container-storage.svg": 76721,
	"./continue.svg": 89814,
	"./controller-card-s.svg": 10826,
	"./controller-card.svg": 10878,
	"./controller-high-usage-bg.svg": 52772,
	"./controller-high-usage-legend.svg": 75034,
	"./controller-normal-usage-bg.svg": 78724,
	"./controller-normal-usage-legend.svg": 26078,
	"./create-ad-domain.svg": 23512,
	"./create-cloud-tier-NFS.svg": 61504,
	"./create-cloud-tier-bucket-NFS.svg": 7747,
	"./create-cloud-tier-bucketname.svg": 46286,
	"./create-cloud-tier-no-local.svg": 75564,
	"./create-cloud-tier-when-hypro.svg": 55286,
	"./create-cloud-tier.svg": 40997,
	"./create-hypermetro.svg": 36458,
	"./create-hyperreplication.svg": 45508,
	"./create-ldap-domain.svg": 32777,
	"./create-nis-domain.svg": 72847,
	"./data-reduction-s.svg": 56050,
	"./dataTurbo.svg": 59093,
	"./deploy-application-main.svg": 28622,
	"./deploy-application-success.svg": 39237,
	"./deploy-backup-app.svg": 45032,
	"./deployed-backup-app.svg": 2863,
	"./deploying-backup-app.svg": 5817,
	"./deployment-mode.svg": 2946,
	"./device-batch-configuration.svg": 83433,
	"./device-export-data.svg": 56244,
	"./device-restart.svg": 20106,
	"./device-shutdown.svg": 35085,
	"./device-upgrade.svg": 98483,
	"./device.svg": 71022,
	"./diagnosis-expand.svg": 80179,
	"./diagnosis-fault.svg": 26807,
	"./diagnosis-filter-fault.svg": 77642,
	"./diagnosis-filter-unfinished.svg": 71377,
	"./diagnosis-node-fault.svg": 7326,
	"./diagnosis-node-loading.svg": 81948,
	"./diagnosis-node-normal.svg": 90781,
	"./diagnosis-node-unfinished.svg": 7516,
	"./diagnosis-normal.svg": 64224,
	"./diagnosis-running.svg": 58639,
	"./disk-card-s.svg": 40030,
	"./disk-card.svg": 31414,
	"./disk-download.svg": 27976,
	"./disk-high-usage-bg.svg": 82166,
	"./disk-high-usage-legend.svg": 47076,
	"./disk-normal-usage-bg.svg": 13275,
	"./disk-normal-usage-legend.svg": 51246,
	"./domain-device.svg": 7945,
	"./double-arrow.svg": 67162,
	"./down.svg": 67682,
	"./download-disabled.svg": 7354,
	"./download.svg": 23130,
	"./dtree-common.svg": 74301,
	"./e-service.svg": 51749,
	"./enclosure-card-s.svg": 50784,
	"./enclosure-card.svg": 93585,
	"./enhanced.svg": 49882,
	"./error-s.svg": 65344,
	"./error.svg": 18209,
	"./event-enable.svg": 58173,
	"./external-dev.svg": 14225,
	"./fault-tree-diagnosis.svg": 68545,
	"./file-service-setting.svg": 96057,
	"./file-service.svg": 92672,
	"./file-share-choosen.svg": 23164,
	"./file-share-recommended.svg": 60373,
	"./file-storage-service.svg": 60173,
	"./file-system.svg": 81196,
	"./filesystem-migration-detail.svg": 95705,
	"./forecast.svg": 1927,
	"./front-port-high-usage-bg.svg": 9727,
	"./front-port-high-usage-legend.svg": 86886,
	"./front-port-normal-usage-bg.svg": 26389,
	"./front-port-normal-usage-legend.svg": 1547,
	"./fusionAdd.svg": 38688,
	"./fusionArrow.svg": 64059,
	"./fusionDisk.svg": 890,
	"./fusionQuota.svg": 80518,
	"./fusionStorage.svg": 28801,
	"./hardware.svg": 39789,
	"./header-alarm-simple.svg": 38344,
	"./header-alarm.svg": 6251,
	"./header-anomaly-simple.svg": 63921,
	"./header-anomaly.svg": 68337,
	"./header-help-simple.svg": 12606,
	"./header-help.svg": 25067,
	"./header-search-focus.svg": 62969,
	"./header-search-new.svg": 61802,
	"./header-search.svg": 85488,
	"./header-setting.svg": 95906,
	"./header-task-simple.svg": 94731,
	"./header-task.svg": 33973,
	"./health-status-faulty.svg": 27451,
	"./health-status-invalid.svg": 44089,
	"./health-status-normal.svg": 62740,
	"./health-status-write-protected.svg": 89978,
	"./help.svg": 4731,
	"./home-s-capacity-usage.svg": 14171,
	"./home-s-controller-r.svg": 45947,
	"./home-s-controller.svg": 583,
	"./home-s-disk-r.svg": 65056,
	"./home-s-disk.svg": 81769,
	"./home-s-enclosure-r.svg": 50844,
	"./home-s-enclosure.svg": 9865,
	"./home-s-fan-r.svg": 70088,
	"./home-s-fan.svg": 2871,
	"./home-s-port-r.svg": 13775,
	"./home-s-port.svg": 30003,
	"./home-s-power-r.svg": 20397,
	"./home-s-power.svg": 25204,
	"./home-s-resource-file-system.svg": 21655,
	"./home-s-resource-lun.svg": 28697,
	"./home-s-top-qrcode.svg": 15250,
	"./host-sub-menu.svg": 44378,
	"./host.svg": 97394,
	"./hotpatch.svg": 63428,
	"./hyperCDP.svg": 90026,
	"./hypermetro.svg": 15844,
	"./icon-bc-pause.svg": 71181,
	"./icon-cloud.svg": 69442,
	"./icon-collapse.svg": 66388,
	"./icon-create-circle.svg": 6349,
	"./icon-create.svg": 80781,
	"./icon-delete.svg": 5620,
	"./icon-help.svg": 23969,
	"./icon-reset.svg": 21638,
	"./icon-storage-pool.svg": 21190,
	"./icon-update.svg": 66006,
	"./illustration-have-no-access.svg": 13601,
	"./import-config-succeed.svg": 13202,
	"./initialize-host.svg": 99425,
	"./initialize-storage.svg": 82121,
	"./key-service.svg": 73932,
	"./language-en.svg": 37419,
	"./language-ja.svg": 28324,
	"./language-zh.svg": 66894,
	"./layout-list-selected.svg": 18147,
	"./layout-list.svg": 78103,
	"./layout-tree-selected.svg": 50052,
	"./layout-tree.svg": 95389,
	"./left-s.svg": 46660,
	"./left.svg": 80210,
	"./license.svg": 77013,
	"./log-antivirus.svg": 17299,
	"./log-diagnose.svg": 95324,
	"./log-disk.svg": 23686,
	"./log-ftds.svg": 15130,
	"./log-performance.svg": 28338,
	"./log-running-data.svg": 34558,
	"./log-system.svg": 14932,
	"./logo-black.svg": 14578,
	"./logo-s.svg": 65228,
	"./logo.svg": 21283,
	"./long-arrow.svg": 47250,
	"./lun-group-pg.svg": 24326,
	"./lun-group.svg": 56329,
	"./lun-migration-detail.svg": 2207,
	"./lun-setting.svg": 86685,
	"./lun.svg": 6052,
	"./maintenance-record.svg": 25597,
	"./managementBoard-card.svg": 77109,
	"./mapped.svg": 85959,
	"./metro-domain.svg": 12643,
	"./minus.svg": 66436,
	"./mode-switch.svg": 82709,
	"./monitor-s-snapshot.svg": 34888,
	"./monitor-setting.svg": 50842,
	"./monitor.svg": 85325,
	"./move-domain.svg": 71521,
	"./network-cifs.svg": 80228,
	"./network-dataturbo.svg": 82683,
	"./network-error.svg": 42887,
	"./network-eth.svg": 13945,
	"./network-fc.svg": 82491,
	"./network-file.svg": 213,
	"./network-host.svg": 15444,
	"./network-hostgroup.svg": 20956,
	"./network-iscsi.svg": 89534,
	"./network-lun.svg": 30916,
	"./network-lungroup.svg": 50248,
	"./network-nfs.svg": 72645,
	"./network-nvme.svg": 96115,
	"./network-roce.svg": 77532,
	"./network-share.svg": 93361,
	"./network.svg": 58351,
	"./nfs-share.svg": 18466,
	"./nfs.svg": 97698,
	"./not-activated.svg": 41364,
	"./not-enabled.svg": 29975,
	"./not-exist.svg": 77845,
	"./not-support.svg": 43411,
	"./oceanstor9000.svg": 67498,
	"./offline-s.svg": 62647,
	"./online-help.svg": 97453,
	"./ota-requery.svg": 22723,
	"./pause-btn.svg": 90603,
	"./pause-status.svg": 16274,
	"./performance-analysis.svg": 66759,
	"./performance-code-table-bg-2.svg": 65,
	"./phone.svg": 72881,
	"./plans.svg": 98112,
	"./plus-simple.svg": 2823,
	"./plus.svg": 18715,
	"./port-card-s.svg": 60266,
	"./port-card.svg": 79594,
	"./portGroup.svg": 5447,
	"./protect-object.svg": 79655,
	"./protection-cdp-file.svg": 22519,
	"./protection-cdp-lun.svg": 33957,
	"./protection-s-snapshot-once.svg": 32809,
	"./protection-s-snapshot-policy.svg": 9632,
	"./protection.svg": 10068,
	"./provision.svg": 77313,
	"./qrcode-refresh.svg": 20153,
	"./quickstart-data-protection.svg": 24768,
	"./quickstart-export.svg": 95495,
	"./quickstart-resource.svg": 31198,
	"./quorum-server.svg": 68590,
	"./quorum.svg": 16805,
	"./quota.svg": 12234,
	"./reduce-time.svg": 45610,
	"./remove.svg": 72498,
	"./replication-air-gap.svg": 59691,
	"./replication.svg": 91935,
	"./report-capacity-analysis.svg": 50496,
	"./report-performance-analysis.svg": 68763,
	"./report-s-arrow-down.svg": 554,
	"./report-s-arrow-right.svg": 25057,
	"./report.svg": 71393,
	"./resource-detail-s.svg": 68869,
	"./resource-tuning.svg": 68994,
	"./retry-disabled.svg": 27713,
	"./retry.svg": 59810,
	"./right.svg": 81867,
	"./rocket-gray.svg": 9207,
	"./rocket.svg": 59828,
	"./rollback.svg": 20851,
	"./rotate.svg": 75630,
	"./search-common.svg": 29663,
	"./search-done.svg": 48029,
	"./search-favorited.svg": 23652,
	"./search-latest.svg": 66150,
	"./search-recommend.svg": 97286,
	"./search-remove.svg": 95597,
	"./searching.svg": 84128,
	"./server-status--1.svg": 28930,
	"./server-status-0.svg": 230,
	"./server-status-1.svg": 59328,
	"./server-status-2.svg": 95274,
	"./server-status-s-0.svg": 23643,
	"./server-status-s-1.svg": 74414,
	"./server-status-s-2.svg": 10650,
	"./server-status-s-abnormal.svg": 31397,
	"./setting.svg": 88231,
	"./settings-simple-no-data.svg": 60970,
	"./settings.svg": 45103,
	"./simple-alarm-event.svg": 41424,
	"./simple-arrow-down.svg": 80194,
	"./simple-cifs.svg": 38541,
	"./simple-copy.svg": 40863,
	"./simple-create.svg": 44433,
	"./simple-delete.svg": 88099,
	"./simple-dme-iq.svg": 56452,
	"./simple-edit.svg": 81723,
	"./simple-expand.svg": 54470,
	"./simple-file-system.svg": 61581,
	"./simple-hardware.svg": 69923,
	"./simple-home.svg": 78907,
	"./simple-host.svg": 79246,
	"./simple-lun.svg": 17498,
	"./simple-nfs.svg": 46390,
	"./simple-performance-monitor.svg": 83184,
	"./simple-protection.svg": 64288,
	"./simple-remove.svg": 42491,
	"./simple-report.svg": 59930,
	"./simple-settings.svg": 98124,
	"./simple-time-axis.svg": 89073,
	"./simple-time.svg": 76170,
	"./simple-tree-fold.svg": 54690,
	"./simple-tree-unfold.svg": 33726,
	"./slo.svg": 96509,
	"./smart-assistant-active.svg": 73427,
	"./smart-assistant-add-initiator.svg": 12679,
	"./smart-assistant-back.svg": 68639,
	"./smart-assistant-create-host.svg": 93104,
	"./smart-assistant-create-lun.svg": 13237,
	"./smart-assistant-erp.svg": 46021,
	"./smart-assistant-lun-map-to-host.svg": 94059,
	"./smart-assistant-olap.svg": 97215,
	"./smart-assistant-oltp-and-olap.svg": 54925,
	"./smart-assistant-oltp.svg": 93269,
	"./smart-assistant-san.svg": 37354,
	"./smart-assistant-success.svg": 28901,
	"./smart-assistant-switch.svg": 48530,
	"./smart-assistant-unactive.svg": 45231,
	"./smart-assistant-vdi.svg": 36603,
	"./smart-assistant-video-archive.svg": 92964,
	"./smart-fix.svg": 15738,
	"./snapshot.svg": 11440,
	"./snmp-manage.svg": 63732,
	"./something-wrong.svg": 57272,
	"./start-container-main.svg": 66332,
	"./state-normal-s.svg": 79199,
	"./storage-pool-simple.svg": 65107,
	"./storage-pool.svg": 26410,
	"./storage-size.svg": 3378,
	"./storage.svg": 91240,
	"./streamline-copy.svg": 96657,
	"./streamline-diagnostic.svg": 24127,
	"./streamline-dianostic-full-screen.svg": 16965,
	"./streamline-dianostic-qrcode-border-simple.svg": 61118,
	"./streamline-dianostic-qrcode-border.svg": 3615,
	"./streamline-dianostic-qrcode-select.svg": 8141,
	"./streamline-dianostic-qrcode-unselect.svg": 2070,
	"./streamline-dianostic-text-select.svg": 11101,
	"./streamline-dianostic-text-unselect.svg": 66817,
	"./streamline-export.svg": 69827,
	"./succeed-big.svg": 92040,
	"./succeed.svg": 56808,
	"./switch-card-s.svg": 62186,
	"./switch-card.svg": 51464,
	"./system-busy.svg": 16597,
	"./system-upgrade.svg": 98580,
	"./task.svg": 66078,
	"./tasks.svg": 99270,
	"./test-network.svg": 71402,
	"./tier-content-tier.svg": 37622,
	"./time-axis.svg": 97122,
	"./time.svg": 72767,
	"./topo-fs.svg": 62814,
	"./topo-group-body.svg": 45629,
	"./topo-group-enclosure-selected-bg.svg": 83054,
	"./topo-group-enclosure.svg": 67854,
	"./topo-group-head.svg": 20659,
	"./topo-group-item-selected-border-inner-hypermetro.svg": 18462,
	"./topo-group-item-selected-border.svg": 39828,
	"./topo-host.svg": 20118,
	"./topo-lun.svg": 29752,
	"./topo-node-cg.svg": 64130,
	"./topo-node-lun.svg": 31197,
	"./topo-pod.svg": 91358,
	"./topo-port.svg": 11016,
	"./topo-pv.svg": 39345,
	"./topo-s-disk-r.svg": 8245,
	"./topo-s-disk.svg": 88159,
	"./topo-s-host-r.svg": 92223,
	"./topo-s-host.svg": 30994,
	"./topo-s-lun-r.svg": 32729,
	"./topo-s-lun.svg": 27599,
	"./topo-s-port-r.svg": 52959,
	"./topo-s-port.svg": 3102,
	"./unmapped.svg": 89749,
	"./up.svg": 3252,
	"./upgrade-database.svg": 31712,
	"./upgrade-failed.svg": 26588,
	"./upgrade-ing.svg": 55396,
	"./upgrade-license.svg": 42849,
	"./upgrade-pulsign.svg": 88666,
	"./upgrade-suc.svg": 74509,
	"./upgrading.svg": 43725,
	"./user-security.svg": 33258,
	"./user-simple.svg": 88125,
	"./user.svg": 99196,
	"./v-store.svg": 97399,
	"./view-task-info.svg": 58353,
	"./violation.svg": 12532,
	"./voice-disable.svg": 91576,
	"./voice-enable.svg": 26279,
	"./vstore-group.svg": 51112,
	"./vstore-home-file-system.svg": 71350,
	"./vstore-home-hyper-metro.svg": 69855,
	"./vstore-home-logo.svg": 56629,
	"./vstore-home-lun.svg": 46119,
	"./vstore-home-replication.svg": 801,
	"./vstore-home-service.svg": 36218,
	"./warn-s.svg": 44551,
	"./warning.svg": 40368,
	"./weaken.svg": 12433,
	"./x-clone.svg": 11673,
	"./x-hyper-detect.svg": 9533,
	"./x-protect-group.svg": 88917,
	"./x-remote-devices.svg": 32228,
	"./x-replication.svg": 35162,
	"./x-snapshot.svg": 68373,
	"assets/svg/3dc.svg": 13596,
	"assets/svg/Line1-ja-simple.svg": 9157,
	"assets/svg/Line1-ja.svg": 16311,
	"assets/svg/Line1-simple.svg": 72310,
	"assets/svg/Line1.svg": 34859,
	"assets/svg/Line11-ja-simple.svg": 20091,
	"assets/svg/Line11-ja.svg": 44500,
	"assets/svg/Line11-simple.svg": 82447,
	"assets/svg/Line11.svg": 15867,
	"assets/svg/Line2-simple.svg": 99934,
	"assets/svg/Line2.svg": 68630,
	"assets/svg/Line22-simple.svg": 12003,
	"assets/svg/Line22.svg": 5525,
	"assets/svg/active-container-main.svg": 78510,
	"assets/svg/add-gray.svg": 72495,
	"assets/svg/add-protection.svg": 5365,
	"assets/svg/alarm-event-switch.svg": 81812,
	"assets/svg/alarm.svg": 4302,
	"assets/svg/alarms-minor-new.svg": 85806,
	"assets/svg/alarms-status-critical.svg": 72477,
	"assets/svg/alarms-status-info.svg": 45063,
	"assets/svg/alarms-status-major.svg": 86481,
	"assets/svg/alarms-status-minor.svg": 58934,
	"assets/svg/alarms.svg": 63127,
	"assets/svg/analysis-copy.svg": 22248,
	"assets/svg/analysis-delete.svg": 94857,
	"assets/svg/analysis-edit.svg": 28887,
	"assets/svg/analysis.svg": 99445,
	"assets/svg/anomaly-count.svg": 48107,
	"assets/svg/antivirus-service-disable.svg": 20241,
	"assets/svg/antivirus-service-enable.svg": 29570,
	"assets/svg/antivirus-service-error.svg": 66716,
	"assets/svg/antivirus-task-disable.svg": 30168,
	"assets/svg/antivirus-task-enable.svg": 7992,
	"assets/svg/arrow-0.svg": 47095,
	"assets/svg/arrow-100.svg": 1210,
	"assets/svg/arrow-bold-down-red.svg": 78580,
	"assets/svg/arrow-bold-down.svg": 44379,
	"assets/svg/arrow-bold-right-red.svg": 12536,
	"assets/svg/arrow-bold-right.svg": 34964,
	"assets/svg/arrow-both-normal.svg": 86799,
	"assets/svg/arrow-break.svg": 53093,
	"assets/svg/arrow-dotted-detail.svg": 84398,
	"assets/svg/arrow-dotted.svg": 15298,
	"assets/svg/arrow-down.svg": 39817,
	"assets/svg/arrow-fault.svg": 50261,
	"assets/svg/arrow-force-start.svg": 40247,
	"assets/svg/arrow-fs-intra-move-creating.svg": 72768,
	"assets/svg/arrow-fs-intra-move-deleting.svg": 24154,
	"assets/svg/arrow-lg-down.svg": 29478,
	"assets/svg/arrow-lg-top.svg": 83704,
	"assets/svg/arrow-metro-0.svg": 8159,
	"assets/svg/arrow-metro-deleting.svg": 17831,
	"assets/svg/arrow-metro-fault.svg": 34212,
	"assets/svg/arrow-metro-force-start.svg": 68046,
	"assets/svg/arrow-metro-pause.svg": 29940,
	"assets/svg/arrow-metro-to-creating.svg": 1974,
	"assets/svg/arrow-metro-to-recover.svg": 65909,
	"assets/svg/arrow-progress.svg": 77806,
	"assets/svg/arrow-small.svg": 11612,
	"assets/svg/arrow-split.svg": 95699,
	"assets/svg/arrow-standby.svg": 85961,
	"assets/svg/arrow-to-recover.svg": 55816,
	"assets/svg/arrow-top.svg": 35231,
	"assets/svg/arrow-two.svg": 69990,
	"assets/svg/arrow-vstore-force-start.svg": 84584,
	"assets/svg/arrowhead-g.svg": 22234,
	"assets/svg/arrowhead-w.svg": 32865,
	"assets/svg/attachment.svg": 58270,
	"assets/svg/auto-download.svg": 69865,
	"assets/svg/back-port-high-usage-bg.svg": 92826,
	"assets/svg/back-port-high-usage-legend.svg": 46592,
	"assets/svg/back-port-normal-usage-bg.svg": 67877,
	"assets/svg/back-port-normal-usage-legend.svg": 78592,
	"assets/svg/basic-infomation.svg": 15176,
	"assets/svg/black-font-logo.svg": 36583,
	"assets/svg/block-service-setting.svg": 72413,
	"assets/svg/block-service.svg": 52545,
	"assets/svg/cabinet-add.svg": 84197,
	"assets/svg/cancel.svg": 88569,
	"assets/svg/certificate-management.svg": 79148,
	"assets/svg/chart-1-col.svg": 35794,
	"assets/svg/chart-2-col.svg": 40294,
	"assets/svg/check-disabled.svg": 52080,
	"assets/svg/check.svg": 47648,
	"assets/svg/cifs.svg": 29269,
	"assets/svg/clone.svg": 44961,
	"assets/svg/close-thin.svg": 73488,
	"assets/svg/cloude-white.svg": 57589,
	"assets/svg/computeNode-card.svg": 35750,
	"assets/svg/config-container-main.svg": 45738,
	"assets/svg/config-file-not-exist.svg": 87785,
	"assets/svg/config-policy-s-add-btn.svg": 22138,
	"assets/svg/configuration.svg": 997,
	"assets/svg/container-configuration.svg": 58566,
	"assets/svg/container-storage.svg": 76721,
	"assets/svg/continue.svg": 89814,
	"assets/svg/controller-card-s.svg": 10826,
	"assets/svg/controller-card.svg": 10878,
	"assets/svg/controller-high-usage-bg.svg": 52772,
	"assets/svg/controller-high-usage-legend.svg": 75034,
	"assets/svg/controller-normal-usage-bg.svg": 78724,
	"assets/svg/controller-normal-usage-legend.svg": 26078,
	"assets/svg/create-ad-domain.svg": 23512,
	"assets/svg/create-cloud-tier-NFS.svg": 61504,
	"assets/svg/create-cloud-tier-bucket-NFS.svg": 7747,
	"assets/svg/create-cloud-tier-bucketname.svg": 46286,
	"assets/svg/create-cloud-tier-no-local.svg": 75564,
	"assets/svg/create-cloud-tier-when-hypro.svg": 55286,
	"assets/svg/create-cloud-tier.svg": 40997,
	"assets/svg/create-hypermetro.svg": 36458,
	"assets/svg/create-hyperreplication.svg": 45508,
	"assets/svg/create-ldap-domain.svg": 32777,
	"assets/svg/create-nis-domain.svg": 72847,
	"assets/svg/data-reduction-s.svg": 56050,
	"assets/svg/dataTurbo.svg": 59093,
	"assets/svg/deploy-application-main.svg": 28622,
	"assets/svg/deploy-application-success.svg": 39237,
	"assets/svg/deploy-backup-app.svg": 45032,
	"assets/svg/deployed-backup-app.svg": 2863,
	"assets/svg/deploying-backup-app.svg": 5817,
	"assets/svg/deployment-mode.svg": 2946,
	"assets/svg/device-batch-configuration.svg": 83433,
	"assets/svg/device-export-data.svg": 56244,
	"assets/svg/device-restart.svg": 20106,
	"assets/svg/device-shutdown.svg": 35085,
	"assets/svg/device-upgrade.svg": 98483,
	"assets/svg/device.svg": 71022,
	"assets/svg/diagnosis-expand.svg": 80179,
	"assets/svg/diagnosis-fault.svg": 26807,
	"assets/svg/diagnosis-filter-fault.svg": 77642,
	"assets/svg/diagnosis-filter-unfinished.svg": 71377,
	"assets/svg/diagnosis-node-fault.svg": 7326,
	"assets/svg/diagnosis-node-loading.svg": 81948,
	"assets/svg/diagnosis-node-normal.svg": 90781,
	"assets/svg/diagnosis-node-unfinished.svg": 7516,
	"assets/svg/diagnosis-normal.svg": 64224,
	"assets/svg/diagnosis-running.svg": 58639,
	"assets/svg/disk-card-s.svg": 40030,
	"assets/svg/disk-card.svg": 31414,
	"assets/svg/disk-download.svg": 27976,
	"assets/svg/disk-high-usage-bg.svg": 82166,
	"assets/svg/disk-high-usage-legend.svg": 47076,
	"assets/svg/disk-normal-usage-bg.svg": 13275,
	"assets/svg/disk-normal-usage-legend.svg": 51246,
	"assets/svg/domain-device.svg": 7945,
	"assets/svg/double-arrow.svg": 67162,
	"assets/svg/down.svg": 67682,
	"assets/svg/download-disabled.svg": 7354,
	"assets/svg/download.svg": 23130,
	"assets/svg/dtree-common.svg": 74301,
	"assets/svg/e-service.svg": 51749,
	"assets/svg/enclosure-card-s.svg": 50784,
	"assets/svg/enclosure-card.svg": 93585,
	"assets/svg/enhanced.svg": 49882,
	"assets/svg/error-s.svg": 65344,
	"assets/svg/error.svg": 18209,
	"assets/svg/event-enable.svg": 58173,
	"assets/svg/external-dev.svg": 14225,
	"assets/svg/fault-tree-diagnosis.svg": 68545,
	"assets/svg/file-service-setting.svg": 96057,
	"assets/svg/file-service.svg": 92672,
	"assets/svg/file-share-choosen.svg": 23164,
	"assets/svg/file-share-recommended.svg": 60373,
	"assets/svg/file-storage-service.svg": 60173,
	"assets/svg/file-system.svg": 81196,
	"assets/svg/filesystem-migration-detail.svg": 95705,
	"assets/svg/forecast.svg": 1927,
	"assets/svg/front-port-high-usage-bg.svg": 9727,
	"assets/svg/front-port-high-usage-legend.svg": 86886,
	"assets/svg/front-port-normal-usage-bg.svg": 26389,
	"assets/svg/front-port-normal-usage-legend.svg": 1547,
	"assets/svg/fusionAdd.svg": 38688,
	"assets/svg/fusionArrow.svg": 64059,
	"assets/svg/fusionDisk.svg": 890,
	"assets/svg/fusionQuota.svg": 80518,
	"assets/svg/fusionStorage.svg": 28801,
	"assets/svg/hardware.svg": 39789,
	"assets/svg/header-alarm-simple.svg": 38344,
	"assets/svg/header-alarm.svg": 6251,
	"assets/svg/header-anomaly-simple.svg": 63921,
	"assets/svg/header-anomaly.svg": 68337,
	"assets/svg/header-help-simple.svg": 12606,
	"assets/svg/header-help.svg": 25067,
	"assets/svg/header-search-focus.svg": 62969,
	"assets/svg/header-search-new.svg": 61802,
	"assets/svg/header-search.svg": 85488,
	"assets/svg/header-setting.svg": 95906,
	"assets/svg/header-task-simple.svg": 94731,
	"assets/svg/header-task.svg": 33973,
	"assets/svg/health-status-faulty.svg": 27451,
	"assets/svg/health-status-invalid.svg": 44089,
	"assets/svg/health-status-normal.svg": 62740,
	"assets/svg/health-status-write-protected.svg": 89978,
	"assets/svg/help.svg": 4731,
	"assets/svg/home-s-capacity-usage.svg": 14171,
	"assets/svg/home-s-controller-r.svg": 45947,
	"assets/svg/home-s-controller.svg": 583,
	"assets/svg/home-s-disk-r.svg": 65056,
	"assets/svg/home-s-disk.svg": 81769,
	"assets/svg/home-s-enclosure-r.svg": 50844,
	"assets/svg/home-s-enclosure.svg": 9865,
	"assets/svg/home-s-fan-r.svg": 70088,
	"assets/svg/home-s-fan.svg": 2871,
	"assets/svg/home-s-port-r.svg": 13775,
	"assets/svg/home-s-port.svg": 30003,
	"assets/svg/home-s-power-r.svg": 20397,
	"assets/svg/home-s-power.svg": 25204,
	"assets/svg/home-s-resource-file-system.svg": 21655,
	"assets/svg/home-s-resource-lun.svg": 28697,
	"assets/svg/home-s-top-qrcode.svg": 15250,
	"assets/svg/host-sub-menu.svg": 44378,
	"assets/svg/host.svg": 97394,
	"assets/svg/hotpatch.svg": 63428,
	"assets/svg/hyperCDP.svg": 90026,
	"assets/svg/hypermetro.svg": 15844,
	"assets/svg/icon-bc-pause.svg": 71181,
	"assets/svg/icon-cloud.svg": 69442,
	"assets/svg/icon-collapse.svg": 66388,
	"assets/svg/icon-create-circle.svg": 6349,
	"assets/svg/icon-create.svg": 80781,
	"assets/svg/icon-delete.svg": 5620,
	"assets/svg/icon-help.svg": 23969,
	"assets/svg/icon-reset.svg": 21638,
	"assets/svg/icon-storage-pool.svg": 21190,
	"assets/svg/icon-update.svg": 66006,
	"assets/svg/illustration-have-no-access.svg": 13601,
	"assets/svg/import-config-succeed.svg": 13202,
	"assets/svg/initialize-host.svg": 99425,
	"assets/svg/initialize-storage.svg": 82121,
	"assets/svg/key-service.svg": 73932,
	"assets/svg/language-en.svg": 37419,
	"assets/svg/language-ja.svg": 28324,
	"assets/svg/language-zh.svg": 66894,
	"assets/svg/layout-list-selected.svg": 18147,
	"assets/svg/layout-list.svg": 78103,
	"assets/svg/layout-tree-selected.svg": 50052,
	"assets/svg/layout-tree.svg": 95389,
	"assets/svg/left-s.svg": 46660,
	"assets/svg/left.svg": 80210,
	"assets/svg/license.svg": 77013,
	"assets/svg/log-antivirus.svg": 17299,
	"assets/svg/log-diagnose.svg": 95324,
	"assets/svg/log-disk.svg": 23686,
	"assets/svg/log-ftds.svg": 15130,
	"assets/svg/log-performance.svg": 28338,
	"assets/svg/log-running-data.svg": 34558,
	"assets/svg/log-system.svg": 14932,
	"assets/svg/logo-black.svg": 14578,
	"assets/svg/logo-s.svg": 65228,
	"assets/svg/logo.svg": 21283,
	"assets/svg/long-arrow.svg": 47250,
	"assets/svg/lun-group-pg.svg": 24326,
	"assets/svg/lun-group.svg": 56329,
	"assets/svg/lun-migration-detail.svg": 2207,
	"assets/svg/lun-setting.svg": 86685,
	"assets/svg/lun.svg": 6052,
	"assets/svg/maintenance-record.svg": 25597,
	"assets/svg/managementBoard-card.svg": 77109,
	"assets/svg/mapped.svg": 85959,
	"assets/svg/metro-domain.svg": 12643,
	"assets/svg/minus.svg": 66436,
	"assets/svg/mode-switch.svg": 82709,
	"assets/svg/monitor-s-snapshot.svg": 34888,
	"assets/svg/monitor-setting.svg": 50842,
	"assets/svg/monitor.svg": 85325,
	"assets/svg/move-domain.svg": 71521,
	"assets/svg/network-cifs.svg": 80228,
	"assets/svg/network-dataturbo.svg": 82683,
	"assets/svg/network-error.svg": 42887,
	"assets/svg/network-eth.svg": 13945,
	"assets/svg/network-fc.svg": 82491,
	"assets/svg/network-file.svg": 213,
	"assets/svg/network-host.svg": 15444,
	"assets/svg/network-hostgroup.svg": 20956,
	"assets/svg/network-iscsi.svg": 89534,
	"assets/svg/network-lun.svg": 30916,
	"assets/svg/network-lungroup.svg": 50248,
	"assets/svg/network-nfs.svg": 72645,
	"assets/svg/network-nvme.svg": 96115,
	"assets/svg/network-roce.svg": 77532,
	"assets/svg/network-share.svg": 93361,
	"assets/svg/network.svg": 58351,
	"assets/svg/nfs-share.svg": 18466,
	"assets/svg/nfs.svg": 97698,
	"assets/svg/not-activated.svg": 41364,
	"assets/svg/not-enabled.svg": 29975,
	"assets/svg/not-exist.svg": 77845,
	"assets/svg/not-support.svg": 43411,
	"assets/svg/oceanstor9000.svg": 67498,
	"assets/svg/offline-s.svg": 62647,
	"assets/svg/online-help.svg": 97453,
	"assets/svg/ota-requery.svg": 22723,
	"assets/svg/pause-btn.svg": 90603,
	"assets/svg/pause-status.svg": 16274,
	"assets/svg/performance-analysis.svg": 66759,
	"assets/svg/performance-code-table-bg-2.svg": 65,
	"assets/svg/phone.svg": 72881,
	"assets/svg/plans.svg": 98112,
	"assets/svg/plus-simple.svg": 2823,
	"assets/svg/plus.svg": 18715,
	"assets/svg/port-card-s.svg": 60266,
	"assets/svg/port-card.svg": 79594,
	"assets/svg/portGroup.svg": 5447,
	"assets/svg/protect-object.svg": 79655,
	"assets/svg/protection-cdp-file.svg": 22519,
	"assets/svg/protection-cdp-lun.svg": 33957,
	"assets/svg/protection-s-snapshot-once.svg": 32809,
	"assets/svg/protection-s-snapshot-policy.svg": 9632,
	"assets/svg/protection.svg": 10068,
	"assets/svg/provision.svg": 77313,
	"assets/svg/qrcode-refresh.svg": 20153,
	"assets/svg/quickstart-data-protection.svg": 24768,
	"assets/svg/quickstart-export.svg": 95495,
	"assets/svg/quickstart-resource.svg": 31198,
	"assets/svg/quorum-server.svg": 68590,
	"assets/svg/quorum.svg": 16805,
	"assets/svg/quota.svg": 12234,
	"assets/svg/reduce-time.svg": 45610,
	"assets/svg/remove.svg": 72498,
	"assets/svg/replication-air-gap.svg": 59691,
	"assets/svg/replication.svg": 91935,
	"assets/svg/report-capacity-analysis.svg": 50496,
	"assets/svg/report-performance-analysis.svg": 68763,
	"assets/svg/report-s-arrow-down.svg": 554,
	"assets/svg/report-s-arrow-right.svg": 25057,
	"assets/svg/report.svg": 71393,
	"assets/svg/resource-detail-s.svg": 68869,
	"assets/svg/resource-tuning.svg": 68994,
	"assets/svg/retry-disabled.svg": 27713,
	"assets/svg/retry.svg": 59810,
	"assets/svg/right.svg": 81867,
	"assets/svg/rocket-gray.svg": 9207,
	"assets/svg/rocket.svg": 59828,
	"assets/svg/rollback.svg": 20851,
	"assets/svg/rotate.svg": 75630,
	"assets/svg/search-common.svg": 29663,
	"assets/svg/search-done.svg": 48029,
	"assets/svg/search-favorited.svg": 23652,
	"assets/svg/search-latest.svg": 66150,
	"assets/svg/search-recommend.svg": 97286,
	"assets/svg/search-remove.svg": 95597,
	"assets/svg/searching.svg": 84128,
	"assets/svg/server-status--1.svg": 28930,
	"assets/svg/server-status-0.svg": 230,
	"assets/svg/server-status-1.svg": 59328,
	"assets/svg/server-status-2.svg": 95274,
	"assets/svg/server-status-s-0.svg": 23643,
	"assets/svg/server-status-s-1.svg": 74414,
	"assets/svg/server-status-s-2.svg": 10650,
	"assets/svg/server-status-s-abnormal.svg": 31397,
	"assets/svg/setting.svg": 88231,
	"assets/svg/settings-simple-no-data.svg": 60970,
	"assets/svg/settings.svg": 45103,
	"assets/svg/simple-alarm-event.svg": 41424,
	"assets/svg/simple-arrow-down.svg": 80194,
	"assets/svg/simple-cifs.svg": 38541,
	"assets/svg/simple-copy.svg": 40863,
	"assets/svg/simple-create.svg": 44433,
	"assets/svg/simple-delete.svg": 88099,
	"assets/svg/simple-dme-iq.svg": 56452,
	"assets/svg/simple-edit.svg": 81723,
	"assets/svg/simple-expand.svg": 54470,
	"assets/svg/simple-file-system.svg": 61581,
	"assets/svg/simple-hardware.svg": 69923,
	"assets/svg/simple-home.svg": 78907,
	"assets/svg/simple-host.svg": 79246,
	"assets/svg/simple-lun.svg": 17498,
	"assets/svg/simple-nfs.svg": 46390,
	"assets/svg/simple-performance-monitor.svg": 83184,
	"assets/svg/simple-protection.svg": 64288,
	"assets/svg/simple-remove.svg": 42491,
	"assets/svg/simple-report.svg": 59930,
	"assets/svg/simple-settings.svg": 98124,
	"assets/svg/simple-time-axis.svg": 89073,
	"assets/svg/simple-time.svg": 76170,
	"assets/svg/simple-tree-fold.svg": 54690,
	"assets/svg/simple-tree-unfold.svg": 33726,
	"assets/svg/slo.svg": 96509,
	"assets/svg/smart-assistant-active.svg": 73427,
	"assets/svg/smart-assistant-add-initiator.svg": 12679,
	"assets/svg/smart-assistant-back.svg": 68639,
	"assets/svg/smart-assistant-create-host.svg": 93104,
	"assets/svg/smart-assistant-create-lun.svg": 13237,
	"assets/svg/smart-assistant-erp.svg": 46021,
	"assets/svg/smart-assistant-lun-map-to-host.svg": 94059,
	"assets/svg/smart-assistant-olap.svg": 97215,
	"assets/svg/smart-assistant-oltp-and-olap.svg": 54925,
	"assets/svg/smart-assistant-oltp.svg": 93269,
	"assets/svg/smart-assistant-san.svg": 37354,
	"assets/svg/smart-assistant-success.svg": 28901,
	"assets/svg/smart-assistant-switch.svg": 48530,
	"assets/svg/smart-assistant-unactive.svg": 45231,
	"assets/svg/smart-assistant-vdi.svg": 36603,
	"assets/svg/smart-assistant-video-archive.svg": 92964,
	"assets/svg/smart-fix.svg": 15738,
	"assets/svg/snapshot.svg": 11440,
	"assets/svg/snmp-manage.svg": 63732,
	"assets/svg/something-wrong.svg": 57272,
	"assets/svg/start-container-main.svg": 66332,
	"assets/svg/state-normal-s.svg": 79199,
	"assets/svg/storage-pool-simple.svg": 65107,
	"assets/svg/storage-pool.svg": 26410,
	"assets/svg/storage-size.svg": 3378,
	"assets/svg/storage.svg": 91240,
	"assets/svg/streamline-copy.svg": 96657,
	"assets/svg/streamline-diagnostic.svg": 24127,
	"assets/svg/streamline-dianostic-full-screen.svg": 16965,
	"assets/svg/streamline-dianostic-qrcode-border-simple.svg": 61118,
	"assets/svg/streamline-dianostic-qrcode-border.svg": 3615,
	"assets/svg/streamline-dianostic-qrcode-select.svg": 8141,
	"assets/svg/streamline-dianostic-qrcode-unselect.svg": 2070,
	"assets/svg/streamline-dianostic-text-select.svg": 11101,
	"assets/svg/streamline-dianostic-text-unselect.svg": 66817,
	"assets/svg/streamline-export.svg": 69827,
	"assets/svg/succeed-big.svg": 92040,
	"assets/svg/succeed.svg": 56808,
	"assets/svg/switch-card-s.svg": 62186,
	"assets/svg/switch-card.svg": 51464,
	"assets/svg/system-busy.svg": 16597,
	"assets/svg/system-upgrade.svg": 98580,
	"assets/svg/task.svg": 66078,
	"assets/svg/tasks.svg": 99270,
	"assets/svg/test-network.svg": 71402,
	"assets/svg/tier-content-tier.svg": 37622,
	"assets/svg/time-axis.svg": 97122,
	"assets/svg/time.svg": 72767,
	"assets/svg/topo-fs.svg": 62814,
	"assets/svg/topo-group-body.svg": 45629,
	"assets/svg/topo-group-enclosure-selected-bg.svg": 83054,
	"assets/svg/topo-group-enclosure.svg": 67854,
	"assets/svg/topo-group-head.svg": 20659,
	"assets/svg/topo-group-item-selected-border-inner-hypermetro.svg": 18462,
	"assets/svg/topo-group-item-selected-border.svg": 39828,
	"assets/svg/topo-host.svg": 20118,
	"assets/svg/topo-lun.svg": 29752,
	"assets/svg/topo-node-cg.svg": 64130,
	"assets/svg/topo-node-lun.svg": 31197,
	"assets/svg/topo-pod.svg": 91358,
	"assets/svg/topo-port.svg": 11016,
	"assets/svg/topo-pv.svg": 39345,
	"assets/svg/topo-s-disk-r.svg": 8245,
	"assets/svg/topo-s-disk.svg": 88159,
	"assets/svg/topo-s-host-r.svg": 92223,
	"assets/svg/topo-s-host.svg": 30994,
	"assets/svg/topo-s-lun-r.svg": 32729,
	"assets/svg/topo-s-lun.svg": 27599,
	"assets/svg/topo-s-port-r.svg": 52959,
	"assets/svg/topo-s-port.svg": 3102,
	"assets/svg/unmapped.svg": 89749,
	"assets/svg/up.svg": 3252,
	"assets/svg/upgrade-database.svg": 31712,
	"assets/svg/upgrade-failed.svg": 26588,
	"assets/svg/upgrade-ing.svg": 55396,
	"assets/svg/upgrade-license.svg": 42849,
	"assets/svg/upgrade-pulsign.svg": 88666,
	"assets/svg/upgrade-suc.svg": 74509,
	"assets/svg/upgrading.svg": 43725,
	"assets/svg/user-security.svg": 33258,
	"assets/svg/user-simple.svg": 88125,
	"assets/svg/user.svg": 99196,
	"assets/svg/v-store.svg": 97399,
	"assets/svg/view-task-info.svg": 58353,
	"assets/svg/violation.svg": 12532,
	"assets/svg/voice-disable.svg": 91576,
	"assets/svg/voice-enable.svg": 26279,
	"assets/svg/vstore-group.svg": 51112,
	"assets/svg/vstore-home-file-system.svg": 71350,
	"assets/svg/vstore-home-hyper-metro.svg": 69855,
	"assets/svg/vstore-home-logo.svg": 56629,
	"assets/svg/vstore-home-lun.svg": 46119,
	"assets/svg/vstore-home-replication.svg": 801,
	"assets/svg/vstore-home-service.svg": 36218,
	"assets/svg/warn-s.svg": 44551,
	"assets/svg/warning.svg": 40368,
	"assets/svg/weaken.svg": 12433,
	"assets/svg/x-clone.svg": 11673,
	"assets/svg/x-hyper-detect.svg": 9533,
	"assets/svg/x-protect-group.svg": 88917,
	"assets/svg/x-remote-devices.svg": 32228,
	"assets/svg/x-replication.svg": 35162,
	"assets/svg/x-snapshot.svg": 68373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87138;